//export const MEAT_API = 'http://localhost:3000'

export const MEAT_API = 'https://www.chutesfutmesa.com.br/apichutesfutmesa'

//export const MEAT_APP = 'http://localhost:4200'

export const MEAT_APP = 'https://www.chutesfutmesa.com.br'

export const DIR_CLUBE = 'assets/images/logos clubes/'

export const DIR_JOGADOR = 'assets/images/fotosJogadores/'

export const DIR_COMPETICAO = 'assets/images/fotosCompeticoes/'

export const DIR_EQUIPE = 'assets/images/fotosEquipes/'

export const DIR_EXCEL_RANKINHG = 'assets/rankingFPFM/'

